// import React, { useContext } from "react";
// import { Button, Box, Typography } from "@mui/material";
// import AuthContext from "../../contexts/AuthContext";
// import { useNavigate } from "react-router-dom";

// const SelectRole = ({ inviteTypes }) => {
//   const { selectedUserData, setTypeOfUser } = useContext(AuthContext);
//   const navigate = useNavigate();
//   console.log("inviteTypesssssssssss", inviteTypes, selectedUserData);

//   const handleRoleSelect = (role) => {
//     console.log('role', role);
//     localStorage.setItem("selectedRole", role);
//     setTypeOfUser(role);

//     if (role === 'SCHOOLADMIN') navigate('/schoolAdmin');
//     else if (role === 'ADMIN') navigate('/admin');
//     else navigate('/');
//   };

//   const roles = selectedUserData?.profile?.roles || [];

//   const displayRoles = roles?.length > 0 ? roles : inviteTypes;

//   return (
//     <Box sx={{ p: 4, textAlign: "center" }}>
//       <Typography variant="h5" gutterBottom>
//         Select Your Role
//       </Typography>
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
//         {displayRoles.map((role) => (
//           <Button
//             key={role}
//             variant="contained"
//             onClick={() => handleRoleSelect(role)}
//           >
//             {role}
//           </Button>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default SelectRole;

import React, { useContext } from 'react';
import { Button, Box, Typography, Card, CardContent } from '@mui/material';
import AuthContext from '../../contexts/AuthContext';
import NewLogo from '../../components/BrandLogo';
import { useNavigate } from 'react-router-dom';

const SelectRole = ({ inviteTypes }) => {
  const { selectedUserData, setTypeOfUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    localStorage.setItem('selectedRole', role);
    setTypeOfUser(role);

    // Navigate to appropriate dashboard based on role
    switch (role) {
      case 'SCHOOLADMIN':
        navigate('/schoolAdmin');
        break;
      case 'TEACHER':
        navigate('/');
        break;
      case 'ADMIN':
        navigate('/admin');
        break;
      case 'ORGANIZATIONADMIN':
        navigate('/organizationAdmin');
        break;
      default:
        navigate('/');
        break;
    }
  };

  const roles = selectedUserData?.profile?.roles || [];
  const displayRoles = roles?.length > 0 ? roles : inviteTypes;

  return (
    // <Box
    //   sx={{
    //     width: '100%',
    //     minHeight: '100vh',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     p: 4,
    //     textAlign: 'center',
    //   }}
    // >
    //   <NewLogo newline={false} />
    //   <Typography
    //     variant='h4'
    //     sx={{ mt: 2, fontFamily: 'Lato', fontWeight: 400 }}
    //   >
    //     Welcome to Mindly.
    //   </Typography>
    //   <Typography
    //     variant='subtitle1'
    //     sx={{
    //       color: 'var(--clr-theme-gray)',
    //       fontFamily: 'Karla',
    //       fontWeight: 700,
    //       mt: 1,
    //     }}
    //   >
    //     Please select your role to proceed
    //   </Typography>

    //   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4 }}>
    //     {displayRoles.map((role) => (
    //       <Button
    //         key={role}
    //         variant='contained'
    //         onClick={() => handleRoleSelect(role)}
    //         sx={{ textTransform: 'capitalize', fontFamily: 'Karla' }}
    //       >
    //         {role}
    //       </Button>
    //     ))}
    //   </Box>
    // </Box>
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f3f4f6', // light background
        p: 10,
      }}
    >
      <Card
        sx={{
          maxWidth: 420,
          width: '100%',
          p: 3,
          borderRadius: 4,
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Box sx={{ textAlign: 'center' }}>
            <NewLogo newline={false} />

            <Typography
              variant='h5'
              sx={{ mt: 2, fontFamily: 'Lato', fontWeight: 400 }}
            >
              Welcome to Mindly.
            </Typography>

            <Typography
              variant='subtitle1'
              sx={{
                color: 'var(--clr-theme-gray)',
                fontFamily: 'Karla',
                fontWeight: 700,
                mt: 1,
              }}
            >
              Please select one role to proceed
            </Typography>
          </Box>

          <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {displayRoles?.map((role) => (
              <Button
                key={role}
                variant='contained'
                onClick={() => handleRoleSelect(role)}
                sx={{
                  textTransform: 'capitalize',
                  fontFamily: 'Karla',
                  backgroundColor: 'var(--clr-theme-purple)',
                  '&:hover': {
                    backgroundColor:'var(--clr-theme-purple-50)',
                  },
                  '&:disabled': {
                    color: 'var(--clr-theme-white) !important',
                    backgroundColor: 'rgb(211, 211, 211) !important',
                  },
                }}
              >
                {role}
              </Button>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SelectRole;
